import { i18n } from '@/plugins/i18n'


export const IvrShopTypes = {
     IVR : 1,
     VIP : 2,
}

export const IvrShopTypesStr = {
     IVR : i18n.t('ivr.shop_types.ivr'),
     VIP : i18n.t('ivr.shop_types.vip'),
     get(shop_type) {
          let shop_type_str = null;
          Object.keys(IvrShopTypes).forEach(function (item) {
               if(IvrShopTypes[item] === shop_type) {
                    shop_type_str = IvrShopTypes[item]
               }
          })

          return shop_type_str
     }
}